import React from "react";
import { Button, Stack } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const CommonButton = ({
  onSubmit,
  onClose,
  isLoading,
  buttonText = "Save",
}) => {
  return (
    <Stack direction="row" spacing={2} justifyContent="flex-end" py={2}>
      <Button
        type="button"
        variant="outlined"
        color="primary"
        onClick={onClose}
        sx={{ px: 4 }}
      >
        Close
      </Button>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={isLoading}
        sx={{ px: 4 }}
      >
        {isLoading ? (
          <>
            <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
            Loading...
          </>
        ) : (
          buttonText
        )}
      </Button>
    </Stack>
  );
};

export default CommonButton;
